import React, {Component} from 'react';
import {translate} from 'react-i18next';

class SupporterEmergencyContactBlock extends Component {

    constructor(props) {
        super(props);

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.reloadEmergencyContact = this.reloadEmergencyContact.bind(this);
    }

    componentDidMount() {
        this.props.getEmergencyContact(this.props.supporterId);
    }

    reloadEmergencyContact() {
        this.props.getEmergencyContact(this.props.supporterId);
    }

    handleFormSubmit(e) {
        e.preventDefault();
        let {supporterEmergencyContact} = this.props;
        this.props.handleFormSubmit(Object.assign({}, supporterEmergencyContact, {id: this.props.supporterId}));
    }

    render() {
        const {t, supporterEmergencyContact} = this.props;
        return (
            <div className="ibox SupporterEmergencyContactBlock">
                <form className="form-inline-edit" onSubmit={this.handleFormSubmit}>
                    <div className="ibox-title">
                        <h5>{t('supporterScreen.supporterEmergencyContact.title')}</h5>
                        <div className="ibox-tools">
                            {supporterEmergencyContact.edit ? (
                                <div>
                                    <a onClick={this.reloadEmergencyContact} className="btn btn-default m-r-xs">
                                        <i className="fa fa-undo"/>
                                    </a>
                                    <button type="submit" className="btn btn-primary"
                                            disabled={supporterEmergencyContact.loading}>
                                        {supporterEmergencyContact.loading ? (
                                            <i className='fa fa-spinner fa-spin inline-block m-r'/>
                                        ) : null}
                                        <i className="fa fa-save"/>
                                    </button>
                                </div>
                            ) : (
                                <a onClick={this.props.editEmergencyContact}>
                                    <i className="fa fa-pencil fa-1-5x"/>
                                </a>
                            )}
                        </div>
                    </div>
                    <div className="ibox-content">
                        <div className="row">
                            <div className="col-xs-6">
                                <div
                                    className={"form-group" + ((supporterEmergencyContact.errors && supporterEmergencyContact.errors.lastname) ? ' has-error' : '')}>
                                    <label>{t('supporterEmergencyContact.lastname.label')}</label>
                                    <input className="form-control" name="lastname"
                                           value={supporterEmergencyContact.lastname}
                                           readOnly={!supporterEmergencyContact.edit}
                                           onChange={this.props.handleInputChange}/>
                                    {(supporterEmergencyContact.errors && supporterEmergencyContact.errors.lastname) ? (
                                        <span className="help-block">
                                            {t('supporterEmergencyContact.lastname.error.' + supporterEmergencyContact.errors.lastname)}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <div
                                    className={"form-group" + ((supporterEmergencyContact.errors && supporterEmergencyContact.errors.firstname) ? ' has-error' : '')}>
                                    <label>{t('supporterEmergencyContact.firstname.label')}</label>
                                    <input className="form-control" name="firstname"
                                           value={supporterEmergencyContact.firstname}
                                           readOnly={!supporterEmergencyContact.edit}
                                           onChange={this.props.handleInputChange}/>
                                    {(supporterEmergencyContact.errors && supporterEmergencyContact.errors.firstname) ? (
                                        <span className="help-block">
                                            {t('supporterEmergencyContact.firstname.error.' + supporterEmergencyContact.errors.firstname)}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                <div
                                    className={"form-group" + ((supporterEmergencyContact.errors && supporterEmergencyContact.errors.phone) ? ' has-error' : '')}>
                                    <label>{t('supporterEmergencyContact.phone.label')}</label>
                                    <input className="form-control" name="phone" value={supporterEmergencyContact.phone}
                                           readOnly={!supporterEmergencyContact.edit}
                                           onChange={this.props.handleInputChange}/>
                                    {(supporterEmergencyContact.errors && supporterEmergencyContact.errors.phone) ? (
                                        <span className="help-block">
                                            {t('supporterEmergencyContact.phone.error.' + supporterEmergencyContact.errors.phone)}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <div
                                    className={"form-group" + ((supporterEmergencyContact.errors && supporterEmergencyContact.errors.type) ? ' has-error' : '')}>
                                    <label>{t('supporterEmergencyContact.type.label')}</label>
                                    {!supporterEmergencyContact.edit ? (
                                        <input type="text" className="form-control" readOnly={true}
                                               value={supporterEmergencyContact.type ? supporterEmergencyContact.type : ''}/>
                                    ) : (
                                        <select className="form-control" name="type"
                                                value={supporterEmergencyContact.type ? supporterEmergencyContact.type : ''}
                                                readOnly={!supporterEmergencyContact.edit}
                                                onChange={this.props.handleInputChange}>
                                            {supporterEmergencyContact.availableTypes ? supporterEmergencyContact.availableTypes.map((type) => (
                                                <option value={type} key={type}>{type}</option>
                                            )) : null}
                                        </select>
                                    )}
                                    {(supporterEmergencyContact.errors && supporterEmergencyContact.errors.type) ? (
                                        <span className="help-block">
                                            {t('supporterEmergencyContact.type.error.' + supporterEmergencyContact.errors.type)}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

export default translate()(SupporterEmergencyContactBlock);